import {DynamicObject5, SuperBit_swaggerClient, Vehicle,DynamicObject1, ElementaryPolicyModel} from './superbit-api-models'
import {SimulatorPageModel,LeadModel,VehicleDataModel,SimulatorOfferModel} from './superbit-api-models'
import {GovData1,GovData2, ManulApiModel} from './ManulApiModel'
import generalSettings from '../json/general-settings.json';
import { json } from 'stream/consumers';


export class OfferProductionModel{
    client:any;
    testClient:any;
    serverTestClient:any;
    
    constructor() {

        const apiUrl = localStorage.getItem('apiUrl');
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";

       
        this.client = new SuperBit_swaggerClient(url);
        this.testClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
        this.testClient = new SuperBit_swaggerClient//("https://api.superbit.co.il");
        // this.serverTestClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
    }

    
    
    
    async getOpenProduction(offerId:string){
        return await this.client.simulatorOpenProduction2(offerId);
    }

    async getIsThereOpenProductionByOffer(offerId:string){
        return await this.client.getIsThereOpenProductionByOffer(offerId);
    }

    async getOpenProductionByLead(offerId:string){
        return await this.client.getOpenProductionByLead(offerId);
    }

    async saveDataProduction(productionData:ElementaryPolicyModel){
        return await this.client.simulatorPolicyProduction(productionData);
    }

    async getUserByRoleId(){
        return await this.client.userGetUserByRoleId('17C211BC-E96C-4EFB-BF17-8025B64EE2D8');
    }

    async deleteFile(id:string){
        return await this.client.deleteFiledAttachment(id);
    }

    async getPolicyStatuses() {
        return await this.client.getElementaryPolicyStatuses();
    }
    async addPolicyStatus(body: any) {
        return this.client.addElementaryPolicyStatus(body);
    }

    async deletePolicyStatus(id: string) {
        return this.client.deleteElementaryPolicyStatus(id);
    }

    async simulatorOpenGetProduction(offerId:string){
        return await this.client.simulatorOpenGetProduction(offerId);
    }

    async simulatorLoadProduction(offerId:string,offerIdToCopy: string){
        return await this.client.simulatorLoadProduction(offerId,offerIdToCopy);
    }

    // saveProduction(offerId:string, production:SimulatorPageModel){

    //     return this.client.simulatorSaveProduction(offerId, production); // need to create the function simulatorSaveProduction in the api-models
    // }
}

